import { BillingTypeBuyOptionModelType } from '@teinor/erp/types/company/config/billingGroup/billingTypeBuy/billingTypeBuyOption'
import { useParams } from 'react-router'
import { ComponentWithPermissions } from '../../../../../../../baseComponents/CreateRoutering/types'
import { CustomRenderString, EditRow } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import BaseScreenTable from '../../../../../../../baseComponents/TwinTable/BaseScreenTable'
import { ColumnTableSchema } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import TwinTable from '../../../../../../../baseComponents/TwinTable'
import ModalCEConfigBillingTypeBuyOption from './ModalCEConfigBillingTypeBuyOption'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import useBillingDictTypes from '../../../../../../../utils/hooks/billingGroups/useBillingDictTypes'

interface ConfigBillingTypeBuyOptionsProps extends ComponentWithPermissions { }

const ConfigBillingTypeBuyOptions: React.FC<ConfigBillingTypeBuyOptionsProps> = ({ userPermissions }) => {
    const { t } = useTwinTranslation()
    const pageData = {
        title: t('options', 'Opciones'),
        newText: t('newOption', 'Nueva opción'),
    }

    return (
        <BaseScreenTable TableComponent={TableConfigBillingTypeBuyOptions} CreateModalComponent={ModalCEConfigBillingTypeBuyOption} EditModalComponent={ModalCEConfigBillingTypeBuyOption} pageData={pageData} userPermissions={userPermissions} />
    )
}

interface TableConfigBillingTypeBuyOptionsProps extends TableComponentProps { }

const TableConfigBillingTypeBuyOptions: React.FC<TableConfigBillingTypeBuyOptionsProps> = ({ setTableInstance, userPermissions, setOpened, tableInstance }) => {
    const { t } = useTwinTranslation()
    const { BillingTypeBuyId } = useParams()
    const { dictTypeBilling, dictImportType, dictRetentionType, dictVatSupportedType} = useBillingDictTypes()
    const extraWhereParams = { 'BillingTypeBuyId': BillingTypeBuyId ? parseInt(BillingTypeBuyId) : null }
    const columns: ColumnTableSchema<BillingTypeBuyOptionModelType> = [
        {
            id: 'code',
            dataKey: 'code',
            label: t('code', 'Código'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('code', 'Código') }
            },
            width: 120
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            sortable: true,
            searchableComponent: {
                component: 'SearchableComponentBasic',
                extraComponentData: { label: t('name', 'Nombre') }
            }
        },
        {
            id: 'typeBilling',
            dataKey: 'typeBilling',
            label: t('typeBilling', 'Tipo de Factura'),
            customRender: (parameterValue) => <CustomRenderString value={dictTypeBilling[parameterValue]?.name} />,
            hideColumnByDefault: true
        },
        {
            id: 'import',
            dataKey: 'import',
            label: t('import', 'Importación'),
            customRender: (parameterValue) => <CustomRenderString value={dictImportType[parameterValue]?.name} />,
            hideColumnByDefault: true
        },
        {
            id: 'retention',
            dataKey: 'retention',
            label: t('retention', 'Retención'),
            customRender: (parameterValue) => <CustomRenderString value={dictRetentionType[parameterValue]?.name} />,
            hideColumnByDefault: true
        },
        {
            id: 'withVat',
            dataKey: 'withVat',
            label: t('withVatW', 'Con IVA'),
            customRender: (parameterValue) => <CustomRenderString value={dictVatSupportedType[parameterValue]?.name} />,
            hideColumnByDefault: true
        },
        {
            id: 'edit',
            dataKey: 'id',
            label: '',
            width: 50,
            customRender: (parameterValue, allRowData) => <EditRow key={'edit' + parameterValue} {...{ parameterValue, allRowData }} onClick={(_idk, allRowData) => setOpened({ type: 'edit', allRowData })} />
        },
    ]
    return (
        <TwinTable columns={columns} name='configBillingTypeBuyOptions' extraWhereParams={extraWhereParams} getDataFrom='/api/app/config/billingGroup/billingTypeBuy/option/getAllBillingTypeBuyOptions' setTableInstance={setTableInstance} defaultOrder={{ defaultOrderField: 'id', order: 'asc' }} hideLoadFiltersButton={true} />
    )

}

export default ConfigBillingTypeBuyOptions